module.exports = __webpack_public_path__ + "img/swift.cb34dfa6.svg";